import * as React from 'react';
import { VideoPlayer } from "../..";
import { StyledVideoContainer } from '../style';
/**
 *
 * @param props ICarouselItemTypeProps
 * @returns VideoPlayerView - component
 */
export const VideoPlayerView = (props) => {
    const { file } = props.carouselViewProps;
    return (React.createElement(StyledVideoContainer, null,
        React.createElement(VideoPlayer, { videoSourceUrl: file.url, isDownloadEnabled: false, mimeType: file.fileType, thumbnailImage: file.thumbnailUrl, shouldDisablePictureInPicture: true, shouldDisableRemotePlayBack: true, shouldDisablePlayBackRate: true })));
};
//# sourceMappingURL=VideoPlayerView.js.map